<div class="container text-center my-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <p class="lead fw-bold">
        {{ 'observatorio.descargar-msg' | translate }}
      </p>
      <div class="d-flex flex-column align-items-center">
        <button
          class="mt-3 px-5 btn-govco outline-btn-govco hvr-shrink"
          (click)="descargar()">
          {{ 'observatorio.descargar-btn' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
